<mat-dialog-content>
    <div class="header">
        <div>
            <h2>{{ headerText | translate: {type: subjectName} }}</h2>
            <h2>{{ subjectTitle | translate: {id: subjectId} }}</h2>
        </div>
        @if (documentation$ | async; as documentation) {
            <app-documentation [documentation]="documentation"></app-documentation>
        }
    </div>
    @if (formData) {
        <ng-container
            [ngTemplateOutlet]="formTemplate"
            [ngTemplateOutletContext]="{formData}"
        ></ng-container>
    } @else if (formDataArray) {
        @for (singleFormData of formDataArray; track $index) {
            <h1>{{ singleFormData?.subject?.name ?? singleFormData?.subject?.id }}</h1>
            <ng-container
                [ngTemplateOutlet]="formTemplate"
                [ngTemplateOutletContext]="{formData: singleFormData}">
            </ng-container>
            <hr>
        }
    }
    <app-button
        class="send-button"
        [buttonType]="'primary'"
        [label]="submitText | translate"
        [disabled]="waitingForResponse || (!formData && !formDataArray)"
        (clickEmitter)="onSubmit()"/>

</mat-dialog-content>

<ng-template let-formData="formData" #formTemplate>
    <form class="typed-form" [formGroup]="formData?.formGroup">
        @for (data of formData?.typedFormData; track data) {
            @switch (data.propertyField.fieldType) {
                @case ("boolean") {
                    <mat-checkbox formControlName="{{data.propertyField.fieldName}}" class="input-field"
                                  [labelPosition]="'before'" [color]="'primary'">
                        {{ data.propertyField.fieldName }}
                    </mat-checkbox>
                }
                @case ("number") {
                    <mat-form-field class="input-field" subscriptSizing="dynamic">
                        <mat-label>{{ data.propertyField.fieldName }}</mat-label>
                        <input matInput type="number" formControlName="{{data.propertyField.fieldName}}"/>
                    </mat-form-field>
                }
                @case ("string") {
                    <mat-form-field class="input-field" subscriptSizing="dynamic">
                        <mat-label>{{ data.propertyField.fieldName }}</mat-label>
                        <input matInput type="text" formControlName="{{data.propertyField.fieldName}}"/>
                    </mat-form-field>
                }
                @case ("object") {
                    @if (data.propertyField.required) {
                        <label for="{{data.propertyField.fieldName}}">{{ data.propertyField.fieldName }}*</label>
                    } @else {
                        <label for="{{data.propertyField.fieldName}}">{{ data.propertyField.fieldName }}</label>
                    }
                    <json-editor
                        id="{{data.propertyField.fieldName}}"
                        class="json-editor"
                        [options]="data.editorOptions"
                        formControlName="{{data.propertyField.fieldName}}"
                    />
                }
                @case ("array") {
                    @if (data.propertyField.required) {
                        <label for="{{data.propertyField.fieldName}}">{{ data.propertyField.fieldName }}*</label>
                    } @else {
                        <label for="{{data.propertyField.fieldName}}">{{ data.propertyField.fieldName }}</label>
                    }
                    <json-editor
                        id="{{data.propertyField.fieldName}}"
                        [options]="data.editorOptions"
                        formControlName="{{data.propertyField.fieldName}}"
                        class="json-editor"
                    />
                }
                @default {
                    <mat-form-field class="input-field" subscriptSizing="dynamic">
                        <mat-label>{{ data.propertyField.fieldName }}</mat-label>
                        <input matInput type="text" formControlName="{{data.propertyField.fieldName}}"/>
                    </mat-form-field>
                }
            }
        }
    </form>
</ng-template>
